import { Card, Typography, makeStyles } from '@material-ui/core'
import React from 'react'
import DragZoneUpload from './DragZoneUpload'
import ImportExportIcon from '@material-ui/icons/ImportExport'

const useStyles = makeStyles(() => ({
   root: {
      height: '250px',
      overflow: 'auto'
   },
   Card: {
      borderTop: '4px solid #1665D8',
      margin: 2,
      paddingTop: 10,
      padding: 15
   },
   title: {
      fontSize: 16,
      fontWeight: 700
   },
   container: {
      margin: '10px'
   }
}))

const DragZoneCard = ({ formats, fileListCallback }) => {
   const classes = useStyles()

   const handleFileSelected = files => {
      fileListCallback(files)
   }

   return (
      <div>
         <Card className={classes.Card}>
            <Typography className={classes.title} variant="h6">
               <span className={classes.circleIcon}>
                  <ImportExportIcon fontSize="small" style={{ width: 26 }} />
               </span>
               Cargar o adjuntar archivo
               <div className={classes.container}>
                  <DragZoneUpload
                     formats={formats}
                     fileListCallback={handleFileSelected}
                  />
               </div>
            </Typography>
         </Card>
      </div>
   )
}

export default DragZoneCard
